var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@/components/ui/Button";
import { Dialog, DialogClose, DialogContent, DialogFooter, DialogHeader, DialogTitle, } from "@/components/ui/Dialog";
import { ResponseModel } from "@/models/ResponseModel";
import { downloadFile } from "@/util/file";
import { toast } from "sonner";
import { ContainerActions } from "./ContainerActions";
import { LabelAction } from "./LabelAction";
import { ScanPayment } from "./ScanPayment";
import { ButtonAction } from "./ButtonAction";
import { cn } from "@/lib/utils";
export function DialogBoletoDetails(_a) {
    var _this = this;
    var service = _a.service, showBoleto = _a.showBoleto, setShowBoleto = _a.setShowBoleto, data = _a.data;
    var isOldVersionBillet = !(data === null || data === void 0 ? void 0 : data.tax.billet.pix.code);
    var copyToClipboard = function (data) {
        try {
            navigator.clipboard.writeText(data);
            toast.success("Copiado com sucesso!");
        }
        catch (e) {
            toast.error("Ocorreu um erro ao copiar o código de barras. Tente novamente.");
        }
    };
    var showBase64Pdf = function () {
        var _a;
        var blob = new Blob([
            Uint8Array.from(atob((_a = data === null || data === void 0 ? void 0 : data.tax.billet.billetPdf) !== null && _a !== void 0 ? _a : ""), function (c) {
                return c.charCodeAt(0);
            }),
        ], { type: "application/pdf" });
        var url = URL.createObjectURL(blob);
        window.open(url, "boleto-detran");
    };
    var download = function () { return __awaiter(_this, void 0, void 0, function () {
        var ret;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, service.download({
                        base64: (_a = data === null || data === void 0 ? void 0 : data.tax.billet.billetPdf) !== null && _a !== void 0 ? _a : "",
                        decoder: "standard",
                        filename: "boleto.pdf",
                        bucketPath: "",
                        contentType: "application/pdf",
                    })];
                case 1:
                    ret = _b.sent();
                    if (ResponseModel.isOk(ret)) {
                        downloadFile(ret.data.url, "boleto.pdf");
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(Dialog, __assign({ open: showBoleto, onOpenChange: function (open) { return setShowBoleto(open); } }, { children: _jsxs(DialogContent, __assign({ className: "bg-secondary sm:max-w-[688px]" }, { children: [_jsx(DialogHeader, __assign({ className: "mb-6 sm:mb-0" }, { children: _jsx(DialogTitle, __assign({ className: "foreground" }, { children: "Boleto de cobran\u00E7a do servi\u00E7o" })) })), _jsx("section", __assign({ className: "hidden sm:w-full sm:max-w-[856px] sm:flex sm:flex-col sm:justify-between sm:px-6 sm:py-3 sm:rounded-lg" }, { children: _jsx(ScanPayment, { data: data.tax, isOldVersionBillet: isOldVersionBillet }) })), _jsxs(ContainerActions, { children: [_jsx(LabelAction, __assign({ label: "Pix Copia e Cola", pixOnly: isOldVersionBillet }, { children: _jsx(ButtonAction, __assign({ onClick: function () { var _a; return copyToClipboard((_a = data === null || data === void 0 ? void 0 : data.tax.billet.pix.code) !== null && _a !== void 0 ? _a : ""); } }, { children: _jsxs("span", { children: ["Copiar ", _jsx("span", __assign({ className: "sm:hidden" }, { children: "c\u00F3digo Pix" }))] }) })) })), _jsx(LabelAction, __assign({ label: "C\u00F3digo de Barras" }, { children: _jsx(ButtonAction, __assign({ onClick: function () { var _a; return copyToClipboard((_a = data === null || data === void 0 ? void 0 : data.tax.billet.barCode.barCodeImage) !== null && _a !== void 0 ? _a : ""); } }, { children: _jsxs("span", { children: ["Copiar ", _jsx("span", __assign({ className: "sm:hidden" }, { children: "c\u00F3digo de barras" }))] }) })) })), _jsx(LabelAction, __assign({ label: "Visualizar boleto", mobileHidden: true }, { children: _jsx(ButtonAction, __assign({ onClick: showBase64Pdf }, { children: "Abrir em uma nova guia" })) })), _jsx(LabelAction, __assign({ label: "Baixar boleto" }, { children: _jsxs(ButtonAction, __assign({ onClick: download, className: cn("bg-primary text-primary-foreground", "hover:bg-primary hover:text-primary-foreground hover:brightness-90", "active:brightness-75") }, { children: ["Baixar ", _jsx("span", __assign({ className: "sm:hidden" }, { children: "boleto" }))] })) }))] }), _jsx(DialogFooter, __assign({ className: "sm:justify-start" }, { children: _jsx(DialogClose, __assign({ asChild: true }, { children: _jsx(Button, __assign({ type: "button", variant: "link", className: "justify-start text-primary text-base", onClick: function () { return setShowBoleto(false); } }, { children: "Fechar" })) })) }))] })) })));
}
